/* eslint-disable  */
import { useTranslate } from 'ra-core';
import React, { useEffect, useState } from 'react';
import { BooleanInput } from '../../../base/components/ra/inputs';
import { useSchema } from '../../../base/hooks';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core//Tooltip';
import { Box, makeStyles, Typography } from '@material-ui/core';

export const customFieldsConfig = ['payoutConfig', 'placebetConfig', 'cancelbetConfig'];

const CustomSelectConfig = ({ source, basePath, implementation }) => {
  const classes = useStyles();

  const translate = useTranslate();

  const [componentInfo, setComponentInfo] = useState({});

  const { api, ref } = useSchema();

  useEffect(() => {
    if (api) {
      const { paths } = api;
      const target = `${basePath}/{id}`;
      let requestRef = paths?.[target]?.patch?.requestBody?.content?.['application/json']?.schema;

      requestRef = requestRef.$ref || requestRef.allOf?.filter((i) => i?.$ref)?.[0]?.$ref;

      const requestComponent = ref.get(requestRef);
      const { properties, required } = requestComponent;

      setComponentInfo(properties[source]);
    }
  }, [api]);

  if (!implementation || implementation === 'TRANSFER') {
    return null;
  }

  return (
    <Box mb={4}>
      <Box display="flex" alignItems={'center'} sx={{ gap: 4 }} mb={1}>
        <Typography variant="h5" className={classes.label}>
          {translate(`resources.wallet-integration.fields.${source}`)}
        </Typography>

        <Tooltip title={translate(componentInfo?.description || '')}>
          <IconButton size="small">
            <InfoIcon className={classes.infoIcon} />
          </IconButton>
        </Tooltip>
      </Box>

      {Object.keys(componentInfo?.properties?.fields || {}).map((key) => {
        const field = componentInfo?.properties?.fields[key];
        if (
          ['createPlayerUrl', 'editBalanceUrl'].includes(key) ||
          ['createPlayerUrl', 'editBalanceUrl'].includes(field)
        ) {
          return null;
        }

        return (
          <BooleanInput
            helperText={false}
            key={key}
            source={`${source}.${key}`}
            defaultValue={field.default}
            label={key}
          />
        );
      })}
    </Box>
  );
};

export default CustomSelectConfig;

const useStyles = makeStyles({
  label: {
    fontSize: 16,
    fontWeight: 600,
  },
  infoIcon: {
    width: 18,
    height: 18,
  },
});
